import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf, pdfH1, pdfH2, pdfH4} from './styles';
import {BoxList} from '../../../components/BoxList/BoxList';
import {EmpionPaper} from '../../../components/EmpionPaper/EmpionPaper';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {LanguageContext} from '../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../layouts/theme/designSystem';

export const ExecutiveSummary = () => {
  const {t} = useTranslation('pdfDomain', {keyPrefix: 'executiveSummary'});
  const currentLanguage = useContext(LanguageContext);
  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const words = data.cultureInformation.cultureType.keywords[currentLanguage].split(',').map((str) => str.trim());
  const cultureTypeName = data.cultureInformation.cultureType.name[currentLanguage];

  const paperStyles: SxProps = {
    backgroundColor: '#ffffff',
    border: `1px solid ${orangeColors[3]}`,
    borderRadius: 2,
    marginTop: 2,
    padding: {xs: 2, md: 3},
  };

  return (
    <Grid padding={3}>
      <Typography variant='h1' sx={pdfH1}>
        {t('pageTitle')}
      </Typography>
      <Typography sx={{...bodyPdf, marginBottom: 2}}>{t('subtitle')}</Typography>

      <EmpionPaper sx={paperStyles}>
        <Box maxWidth='650px' mx='auto'>
          <Typography variant='h4' sx={pdfH4} marginBottom={2}>
            {t('cultureAnalysis')} {cultureTypeName}
          </Typography>

          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 2,
            }}
          >
            <CardMedia
              component='img'
              src={data.cultureInformation.cultureType.imageUrl}
              sx={{flexShrink: 0, height: '150px', width: '150px', objectFit: 'contain'}}
            />
            <BoxList data={words} compact stacked />
          </Box>

          <Box>
            <Typography variant='h2' sx={pdfH2}>
              {t('cultureType', {cultureType: cultureTypeName})}
            </Typography>
            <Typography sx={bodyPdf} mb={1} mt={1}>
              {data.cultureInformation.cultureType.description.paragraphOne[currentLanguage]}
            </Typography>
            <Typography sx={bodyPdf}>
              {data.cultureInformation.cultureType.description.paragraphTwo[currentLanguage]}
            </Typography>
          </Box>
        </Box>
      </EmpionPaper>
    </Grid>
  );
};
